import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";

const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null); // null=checking, false=guest, object=auth
  const token = localStorage.getItem("aarmira_customer_token");

  useEffect(() => {
    const check = async () => {
      if (!token) return setCustomer(false);
      try {
        const { data } = await api.get("/auth/me");
        setCustomer(data);
      } catch {
        localStorage.removeItem("aarmira_customer_token");
        setCustomer(false);
      }
    };
    check();
  }, [token]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("aarmira_customer_token", data.token);
      setCustomer(data.customer);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      localStorage.setItem("aarmira_customer_token", data.token);
      setCustomer(data.customer);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const logout = () => {
    localStorage.removeItem("aarmira_customer_token");
    setCustomer(false);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, login, register, logout }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => useContext(CustomerAuthContext);
